import { Button } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { MerchantOnboardingStatus } from '../../enums/merchant-onboarding-status';
import { OpenComponent } from '../../enums/misc.enum';
import { EnableDisableButtonData } from '../../type/button.types';

interface Props {
  isChecked: number[];
  data: EnableDisableButtonData[] | undefined;
  setComponentManager: (value: React.SetStateAction<OpenComponent>) => void;
  text: string;
}

function UpdateButton(props: Readonly<Props>) {
  const { isChecked, data, setComponentManager, text } = props;
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    setIsDisabled(false);

    if (isChecked.length !== 1) {
      setIsDisabled(true);
      return;
    }

    const checkedEntity = data?.find((item) => {
      return item.entityId === isChecked[0];
    });

    if (!checkedEntity) {
      setIsDisabled(true);
      return;
    }

    // Disable if entity does not have an accountId,
    // is not active, or whose onboarding record is not approved
    if (
      !checkedEntity.accountId ||
      !checkedEntity.isActive ||
      checkedEntity.onboardingStatus !== MerchantOnboardingStatus.APPROVED
    ) {
      setIsDisabled(true);
    }
  }, [isChecked, data]);
  return (
    <Button
      disabled={isDisabled}
      onClick={() => {
        setComponentManager(OpenComponent.UPDATE_USER);
      }}
    >
      {text}
    </Button>
  );
}

export default UpdateButton;
